import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/teacher/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/teacher/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"../../packages/tailwind-config/src/fonts.ts\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":\"400\",\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/log/src/logger-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/rollbar/src/error-boundry.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/rollbar/src/rollbar-context.tsx");
